"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.testCalculateInstallmentPayments = exports.calculateInstallmentPaymentsWithDeposit = exports.calculateInstallmentPaymentsLegacy = exports.calculateInstallmentPayments = void 0;
var Common_1 = require("../models/Common");
var TimeUtils_1 = require("./TimeUtils");
/**
 * Calculates installment payments with configurable options
 * @param totalPrice Total price of the trip
 * @param startDate Booking date
 * @param tripDate Trip start date
 * @param options Optional configuration parameters
 * @returns Array of installment payments with dates and amounts
 */
var calculateInstallmentPayments = function (totalPrice, startDate, tripDate, options) {
    // If deposit is provided, calculate on remaining amount
    var depositAmount = (options === null || options === void 0 ? void 0 : options.depositAmount) || (0, Common_1.Money)(0);
    var priceForInstallments = (0, Common_1.Money)(totalPrice - depositAmount);
    // Minimum amount for installments
    if (priceForInstallments < 400)
        return [];
    // Check if trip is far enough in future based on deposit usage
    var hasDeposit = (options === null || options === void 0 ? void 0 : options.depositAmount) && options.depositAmount > 0;
    var minTripDays = hasDeposit ? 134 : 120; // 4 months + 14 days if using deposit, else 4 months
    // Return empty array if trip isn't far enough away
    if ((0, TimeUtils_1.toMoment)(tripDate).diff((0, TimeUtils_1.toMoment)(startDate), 'days') < minTripDays)
        return [];
    // First installment date (immediate or delayed if deposit is used)
    var firstPaymentDelay = hasDeposit ? options.firstPaymentDelay || 14 : 0;
    var firstPaymentDay = (0, TimeUtils_1.toMoment)(startDate).add(firstPaymentDelay, 'days');
    // Set default minimum interval to 30 days
    var minInterval = (options === null || options === void 0 ? void 0 : options.minIntervalDays) || 30;
    // Last payment date (60 days or 2 months before trip)
    var lastPaymentDay = (0, TimeUtils_1.toMoment)(tripDate).subtract((options === null || options === void 0 ? void 0 : options.daysBeforeTripForLastPayment) || 60, 'days');
    // Check if we have enough time for installments
    var daysBetween = Math.floor(lastPaymentDay.diff(firstPaymentDay, 'days', true));
    if (daysBetween < 0)
        return [];
    // Determine how many installments we can have
    var installments;
    if (minInterval > 0) {
        // If minimum interval is specified, calculate max installments based on that
        var maxInstallments = Math.floor(daysBetween / minInterval) + 1;
        installments = Math.min(4, maxInstallments);
    }
    else {
        // Legacy behavior - calculate based on months
        var fullMonthsBetween = Math.floor(lastPaymentDay.diff(firstPaymentDay, 'months', true));
        if (fullMonthsBetween < 1)
            return [];
        installments = Math.min(4, fullMonthsBetween + 1);
    }
    // Calculate installment amounts
    var payments = [];
    var remaining = priceForInstallments;
    for (var i = 0; i < installments; i += 1) {
        var payment = Math.round(remaining / (installments - i));
        remaining -= payment;
        payments.push(payment);
    }
    payments.sort();
    // Create the installment schedule with dates
    var result = [];
    result.push([(0, TimeUtils_1.toDateString)(firstPaymentDay), (0, Common_1.Money)(payments[0])]);
    if (installments > 1) {
        // Determine the interval between payments
        var intervalDays = minInterval > 0 ? Math.max(minInterval, Math.floor(daysBetween / (installments - 1))) : Math.floor(daysBetween / (installments - 1));
        // Create the remaining installments
        for (var i = 1; i < installments; i += 1) {
            var installmentDate = (0, TimeUtils_1.toDateString)(firstPaymentDay.clone().add(intervalDays * i, 'days'));
            result.push([installmentDate, (0, Common_1.Money)(payments[i])]);
        }
    }
    return result;
};
exports.calculateInstallmentPayments = calculateInstallmentPayments;
// Backwards compatible functions using the new unified function
var calculateInstallmentPaymentsLegacy = function (totalPrice, startDate, tripDate) {
    return (0, exports.calculateInstallmentPayments)(totalPrice, startDate, tripDate);
};
exports.calculateInstallmentPaymentsLegacy = calculateInstallmentPaymentsLegacy;
var calculateInstallmentPaymentsWithDeposit = function (totalPrice, depositAmount, startDate, tripDate) {
    return (0, exports.calculateInstallmentPayments)(totalPrice, startDate, tripDate, {
        depositAmount: depositAmount,
        firstPaymentDelay: 14,
        minIntervalDays: 30,
        daysBeforeTripForLastPayment: 60,
    });
};
exports.calculateInstallmentPaymentsWithDeposit = calculateInstallmentPaymentsWithDeposit;
var testCalculateInstallmentPayments = function () {
    var totalPrice = (0, Common_1.Money)(1000);
    var today = (0, TimeUtils_1.toMoment)((0, Common_1.DateString)('2021-11-01'));
    for (var i = 0; i < 400; i += 1) {
        var tripDate = today.clone().add(i, 'days');
        var installments = (0, exports.calculateInstallmentPayments)(totalPrice, (0, TimeUtils_1.toDateString)(today), (0, TimeUtils_1.toDateString)(tripDate));
        var str = [];
        var prev = undefined;
        for (var _i = 0, installments_1 = installments; _i < installments_1.length; _i++) {
            var _a = installments_1[_i], d = _a[0], p = _a[1];
            var diff = prev ? "(".concat((0, TimeUtils_1.toMoment)(d).diff(prev, 'days'), " days) | ") : '';
            str.push("".concat(diff).concat(d, " $").concat(p));
            prev = d;
        }
        console.log((0, TimeUtils_1.toDateString)(tripDate), ' => ', str.join(' | '));
    }
};
exports.testCalculateInstallmentPayments = testCalculateInstallmentPayments;
//# sourceMappingURL=InstallmentPayments.js.map